import { AxiosRequestConfig } from 'axios'

import { http } from './http'
import { PaginationParams } from './map'
import { searchByTickets } from '../../common/models'

export const searchByEmail = async (
  email?: string,
  festivalName?: string,
  params?: PaginationParams,
) => {
  const config: AxiosRequestConfig = {
    params,
    headers: {},
  }
  if (festivalName && config.headers) {
    config.headers['x-festival-name'] = festivalName
  }
  return http.get<searchByTickets>(`/operations/ticket/search`, {
    params: { email },
  })
}

export const searchByBarcode = async (
  ticketCode?: string,
  festivalName?: string,
  params?: PaginationParams,
) => {
  const config: AxiosRequestConfig = {
    params,
    headers: {},
  }
  if (festivalName && config.headers) {
    config.headers['x-festival-name'] = festivalName
  }
  return http.get<searchByTickets>(`/operations/ticket/search`, {
    params: { ticketCode },
  })
}

export const searchBySerial = async (
  sn?: string,
  festivalName?: string,
  params?: PaginationParams,
) => {
  const config: AxiosRequestConfig = {
    params,
    headers: {},
  }
  if (festivalName && config.headers) {
    config.headers['x-festival-name'] = festivalName
  }
  return http.get<searchByTickets>(`/operations/ticket/search`, {
    params: { sn },
  })
}

export const cancelCheckin = async (checkinId: string) =>
  http.put(`/operations/ticket/checkin/${checkinId}/cancel`)

export const syncWristband = async (barcode: string) =>
  http.put(`/operations/orders/participation-sync/${barcode}/sync-wristband`)

export const cancelDashboardfTicket = async (barcode: string) =>
  http.put(`/operations/helper/migrations/cancel-ticket-codes`, [barcode])

export const getCheckInHistory = async (barcode: string) =>
  http.get(`/operations/ticket/checkin-info/${barcode}`)
